/* 
Allows the connected wallet to move their stake to the current Orchestrator
*/
import { Stack, Text, Group } from "@mantine/core";
import EthAddress from "../../EthAddress/EthAddress";
import { useBondingManager } from "../../../hooks/WithSmartContracts";
import { useState } from "react";
import { ethers } from "ethers";
import SmartContractAction from "../components/SmartContractAction";

export default function MoveStake(props) {
  const [isPending, setIsPending] = useState(false);
  const [thisTxn, setTxn] = useState("");
  const [thisErrMsg, setErrMsg] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const bondingManager = useBondingManager();

  const moveLPT = async () => {
    try {
      const { ethereum } = window;
      if (ethereum) {
        setIsPending(true);
        let hints = null;
        if (props.getHints) {
          hints = props.getHints(
            props.bondedLPT,
            props.bondedWith.toLowerCase(),
            props.orchestratorAddr
          );
        }
        console.log("Calculated hints:");
        console.log(hints);
        if (hints) {
          const txn = await bondingManager.bondWithHint(
            0,
            props.orchestratorAddr,
            hints.oldDelegateNewPosPrev,
            hints.oldDelegateNewPosNext,
            hints.newDelegateNewPosPrev,
            hints.newDelegateNewPosNext
          );
          setTxn(txn.hash);
          await txn.wait();
        } else {
          const txn = await bondingManager.bond(0, props.orchestratorAddr);
          setTxn(txn.hash);
          await txn.wait();
        }
        props.refreshWallet();
        setIsFinished(true);
      }
    } catch (error) {
      if (error.reason) {
        setErrMsg(error.reason);
      }
      props.setErr(true);
      setIsPending(false);
      setTxn(false);
      setIsFinished(false);
    }
  };

  return (
    <Stack spacing={24}>
      <Group position="center" spacing={24}>
        <EthAddress
          address={props.bondedWith}
          cachedENS={props.cachedENS}
          preamble={
            "You are currently staking " +
            (props.bondedLPT / ethers.constants.WeiPerEther).toFixed(2) +
            " LPT at "
          }
        />
      </Group>
      <Group position="center" spacing={24}>
        <EthAddress
          address={props.orchestratorAddr}
          cachedENS={props.cachedENS}
          preamble={
            "You can move your stake to "
          }
        />
      </Group>
      <SmartContractAction
        isPending={isPending}
        txn={thisTxn}
        thisErrMsg={thisErrMsg}
        isFinished={isFinished}
        action={moveLPT}
        actionMessage={"Move Delegated Stake"}
        finishedMessage={"Successfully moved stake!"}
        pendingMessage={"Moving Delegated Stake..."}
      />
      {thisErrMsg != "" ? (
        <Text size="xl" fw={700}>
          The previous transaction failed with reason `{thisErrMsg}`
        </Text>
      ) : null}
    </Stack>
  );
}
